import { 
    COMPANY_BEGIN,
    COMPANY_SUCCESS,
    COMPANY_FAILURE,
    COMPANY_CLEAR,

    COMPANY_FILTER_BEGIN,
    COMPANY_FILTER_SUCCESS,
    COMPANY_FILTER_FAILURE,
    COMPANY_FILTER_CLEAR

} from 'app/actions/CompanyActions';

const initialState = {
	byId: {},
    allIds: [],
    filterData: [],
	isLoading: false,
};

export default function CompanyReducer (state = initialState, action) {
	switch (action.type) {
        case COMPANY_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case COMPANY_SUCCESS:
			let allIds = action.payload.data.Data
			
			return {
				...state,
				allIds,
				isLoading: false,
            };
        case COMPANY_CLEAR:
            return {
                ...state,
                allIds: [],
                isLoading: false,
            }
        case COMPANY_FAILURE: 
			return {
				...state,
				isLoading: false
            }
        case COMPANY_FILTER_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case COMPANY_FILTER_SUCCESS:
            let filterData = [...new Set(state.filterData.concat(action.payload.filterData))];
            return {
                ...state,
                filterData,
                isLoading: false,
            };
        case COMPANY_FILTER_CLEAR:
            return {
                ...state,
                filterData: [],
                isLoading: false,
            }
        case COMPANY_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false
            }
		default:
			return state;
	}
};

export const getCompany = state => {
	return state.allIds;
}

export const getIsLoadingCompany = state => {
    return state.isLoading;
}

export const getCompanyFilter = state => {
    return state.filterData
}
export const getIsLoadingCompanyFilter = state => {
    return state.isLoading;
}